import React, { useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { isNil, get, isEmpty, indexOf } from 'lodash';
import ToggleTabs from 'components/ToggleTabs';
import {
  makeSelectCurrentTabIndexTransaction,
  makeSelectListings,
} from 'containers/AppContainer/selectors';
import JudiciaryProcessTabs from 'components/JudiciaryProcessTabs';
import { TRANSACTIONS_TAB_LABELS } from 'containers/TransactionManagerTimeLine/constants';
import VictimInformation from 'containers/TransactionManagerTimeLine/VictimInfo/index';
import {
  makeSelectContactTransaction,
  makeSelectTransactions,
} from 'containers/TransactionManagerTimeLine/selector';
import {
  formatLabelsTabsTransactions,
  isBlockedTransaction,
} from 'containers/TransactionManagerTimeLine/utils';
import ContactVictim from 'containers/TransactionManagerTimeLine/ContactVictim/index';
import ExpertReport from 'containers/TransactionManagerTimeLine/ExpertReport';
import OfferRegulation from 'containers/TransactionManagerTimeLine/OfferRegulation';
import { ClaimRecapType } from 'typings/claimTypes';

export interface TransactionProps {
  intl: IntlShape;
  match: { params: { claimId: number } };
  claimNumber: string;
  claimRecap: ClaimRecapType;
  policyInfo: any;
  requestGetTransaction: Function;
  resetUploadedDocument: Function;
  uploadedDocument: any;
  uploadDocument: Function;
  requestAddTransaction: Function;
  requestUpdateTransaction: Function;
  requestAddContactTransaction: Function;
  requestGetContactTransaction: Function;
  resetStoreTransaction: Function;
  requestUpdateContactTransaction: Function;
  requestGetExpertUsers: Function;
  corporealExperts: any;
  requestAssignedExpert: Function;
  riskKey: string;
  requestGetMissionTransaction: Function;
  requestMakeDecisionMissionExpertise: Function;
  requestGetMissionVictimExpertise: Function;
  requestUpdateMissionTransaction: Function;
  requestGetFeeNotesTransaction: Function;
  onPressFeeNote: Function;
  isConsultation: boolean;
  expertJudiciaryExpertise: any;
  requestImportMissionExpertise: Function;
  requestGetJudiciaryExpertReport: Function;
  requestMakeDecisionVictimInfo: Function;
  sagisInfo: any;
  currentVerticalTabs?: any;
  storedTransactionId?: any;
  requestLockClaim: Function;
  setLockedClaim: Function;
  requestSetPriorityClaimProvision: Function;
  requestResetHistoryStore: Function;
  currentIndexTabManager: any;
  currentInstanceTabIndexManager: any;
  currentGlobalTabManagerIndex: any;
  currentJudiciaryProccessId: any;
  requestRejectTransaction?: any;
  setCurrentIndexTabTransaction?: any;
  requestGetDahirAmount: Function;
  dahirAmount?: any;
  requestCreateCorporealRegulation: Function;
  requestGetRegulations: Function;
  regulations: any;
  requestSagisClaimInfo: Function;
  requestGetRegulation: Function;
  requestValidateRegulation: Function;
  requestAddQuotationDocument?: Function;
  requestGetDocByDocumentumId: Function;
  isIntervenant?: boolean;
}

const TransactionConsultation: React.FC<TransactionProps> = (
  props,
): JSX.Element => {
  const transactions = useSelector(makeSelectTransactions());
  const listings = useSelector(makeSelectListings());
  const currentVerticalTabs = useSelector(
    makeSelectCurrentTabIndexTransaction(),
  );
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

  const constactTransaction = useSelector(makeSelectContactTransaction());
  useEffect(() => {
    if (props.storedTransactionId && transactions) {
      setCurrentTabIndex(
        indexOf(
          transactions,
          transactions.find((el: any) => el.id === props.storedTransactionId),
        ),
      );
    }
  }, [props.storedTransactionId, transactions]);
  const claimId = props.match.params.claimId;
  useEffect(() => {
    props.requestGetTransaction({
      claimId,
      isIntervenant: props.isIntervenant,
    });
  }, []);
  const handleClickVerticalTabs = (tabIndex: any) => {
    if (props.setCurrentIndexTabTransaction) {
      props.setCurrentIndexTabTransaction(tabIndex);
      props.resetStoreTransaction();
    }
  };

  return (
    <ToggleTabs
      currentTabIndex={currentTabIndex}
      labels={formatLabelsTabsTransactions(transactions)}
    >
      {!isEmpty(transactions) &&
        transactions.map((el: any) => (
          <>
            <JudiciaryProcessTabs
              currentTabIndex={
                isNil(currentVerticalTabs) ? 0 : currentVerticalTabs
              }
              labels={TRANSACTIONS_TAB_LABELS}
              isTransactionTabs={true}
              handleClickVerticalTabsTransaction={handleClickVerticalTabs}
            >
              <VictimInformation
                victim={el.victim}
                listings={listings}
                transactionDocuments={get(el, 'documents', [])}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadedDocument={props.uploadedDocument}
                uploadDocument={props.uploadDocument}
                requestAddTransaction={props.requestAddTransaction}
                requestUpdateTransaction={props.requestUpdateTransaction}
                transactionId={el.id}
                requestGetTransaction={props.requestGetTransaction}
                claimId={claimId}
                claimRecap={props.claimRecap}
                isConsultation={
                  props.isConsultation || isBlockedTransaction(el)
                }
                transactionInfo={el}
                policyInfo={props.policyInfo}
                claimNumber={props.claimNumber}
                riskKey={props.riskKey}
                requestMakeDecisionVictimInfo={
                  props.requestMakeDecisionVictimInfo
                }
                requestRejectTransaction={props.requestRejectTransaction}
                dahirAmounts={props.dahirAmount}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                requestGetDahirAmount={props.requestGetDahirAmount}
              />
              <ContactVictim
                requestAddContactTransaction={
                  props.requestAddContactTransaction
                }
                requestGetContactTransaction={
                  props.requestGetContactTransaction
                }
                contactTransaction={constactTransaction}
                transactionId={el.id}
                listings={listings}
                victim={el.victim}
                transactionDocuments={get(el, 'documents', [])}
                claimId={claimId}
                requestUpdateContactTransaction={
                  props.requestUpdateContactTransaction
                }
                resetStoreTransaction={props.resetStoreTransaction}
                corporealExperts={props.corporealExperts}
                requestGetExpertUsers={props.requestGetExpertUsers}
                requestAssignedExpert={props.requestAssignedExpert}
                claimNumber={props.claimNumber}
                riskKey={props.riskKey}
                requestGetMissionTransaction={
                  props.requestGetMissionTransaction
                }
                requestUpdateMissionTransaction={
                  props.requestUpdateMissionTransaction
                }
                isConsultation={
                  props.isConsultation || isBlockedTransaction(el)
                }
                expertJudiciaryExpertise={props.expertJudiciaryExpertise}
                requestImportMissionExpertise={
                  props.requestImportMissionExpertise
                }
                requestGetJudiciaryExpertReport={
                  props.requestGetJudiciaryExpertReport
                }
                sagisInfo={props.sagisInfo}
                transactionInfo={el}
                lossDate={get(props.claimRecap, 'claim.lossDate')}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                isIntervenant={props.isIntervenant}
                requestGetTransaction={props.requestGetTransaction}
              />
              <ExpertReport
                requestMakeDecisionMissionExpertise={
                  props.requestMakeDecisionMissionExpertise
                }
                claimId={claimId}
                claimNumber={props.claimNumber}
                riskKey={props.riskKey}
                requestGetMissionVictimExpertise={
                  props.requestGetMissionVictimExpertise
                }
                transactionId={el.id}
                setOpenFeeNoteDialog={() => {}}
                requestGetFeeNotesTransaction={
                  props.requestGetFeeNotesTransaction
                }
                onPressFeeNote={props.onPressFeeNote}
                isConsultation={
                  props.isConsultation || isBlockedTransaction(el)
                }
                transactionInfo={el}
                listings={listings}
                responsibilityShare={get(el, 'scaleCase.responsibilityShare')}
                victims={get(props.claimRecap, 'victims', [])}
                lossDate={get(props.claimRecap, 'claim.lossDate')}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                isIntervenant={props.isIntervenant}
              />
              <OfferRegulation
                victim={el.victim}
                listings={listings}
                transactionId={el.id}
                claimId={claimId}
                resetStoreTransaction={props.resetStoreTransaction}
                claimNumber={props.claimNumber}
                riskKey={props.riskKey}
                isConsultation={
                  props.isConsultation || isBlockedTransaction(el)
                }
                sagisInfo={props.sagisInfo}
                transactionInfo={el}
                requestGetDahirAmount={props.requestGetDahirAmount}
                dahirAmount={props.dahirAmount}
                claimInfo={props.claimRecap}
                requestCreateCorporealRegulation={
                  props.requestCreateCorporealRegulation
                }
                policyInfo={props.policyInfo}
                requestGetRegulations={props.requestGetRegulations}
                regulations={props.regulations}
                requestSagisClaimInfo={props.requestSagisClaimInfo}
                requestGetRegulation={props.requestGetRegulation}
                requestValidateRegulation={props.requestValidateRegulation}
                resetUploadedDocument={props.resetUploadedDocument}
                uploadDocument={props.uploadDocument}
                uploadedDocument={props.uploadedDocument}
                requestAddQuotationDocument={props.requestAddQuotationDocument}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
                isIntervenant={props.isIntervenant}
              />
            </JudiciaryProcessTabs>
          </>
        ))}
    </ToggleTabs>
  );
};
export default injectIntl(TransactionConsultation);
